export default function React_Props() {
  return (
    <div>
      <h1>React_Props Component</h1>
      <p>This is the React_Props tutorial page.</p>
    </div>
  );
}
